import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";
import axios from "axios";
import VueAxios from "vue-axios";
import { api } from "@/data/api";
import { createMetaManager } from "vue-meta";
import { guardSite } from "./siteGuard";

axios.defaults.baseURL = api.url;
axios.defaults.headers.common["api-key"] = api.token;

// Zuerst den Verwaltungs-Endpunkt prüfen; die App wird nur bei "Aktiviert" gemountet.
guardSite("vitamin-d-live").then(({ allowed }) => {
  if (!allowed) return;

  createApp(App)
    .use(store)
    .use(router)
    .use(VueAxios, axios)
    .use(createMetaManager())
    .mount("#app");
});
